import TransferMoney from 'features/moveMoney/screens/transfer/TransferMoney/TransferMoney';
import React from 'react';

export default function TransferMoneyPage() {
  return <TransferMoney />;
}
